import { useUserProfileQuery } from 'app/store';
import { Gateway } from 'features/gateways/types/gateway.types';
import { getGatewayAccess } from 'features/gateways/gateway-access.utils';
import { useGateway } from 'hooks';

export const useGatewayAccess = (customGateway?: Gateway) => {
    const activeGateway = useGateway();
    const gateway = customGateway ?? activeGateway;
    const { data: profile } = useUserProfileQuery();

    return {
        gateway,
        ...getGatewayAccess(gateway, profile?.id),
    };
};

export default useGatewayAccess;
